// Text the platform writes for Claude names its tools ("Use send_draft to send it"). The app writes its own words for
// what its buttons did; for the text it passes through (refusal reasons, the reader's notes, exception messages),
// plain() turns tool names into what a person does in the app. Pure, so it is tested without a browser.

/** Whole phrases the platform uses, as a person would say them in the app. Checked first, in order. */
const PHRASES: [RegExp, string][] = [
  [/\s*Use send_draft to send it\.?/g, " Press Send when it's ready."],
  [/review and send it with send_draft/g, "check it, then send it"],
  [/:? ?try vendor_po_pdf\.?/g, ": try Open the PDF."],
  [/\s*see inbox in a minute\.?/g, " look back on Home in a minute."],
  [/;?\s*record (?:what ships|it) with record_agent_shipment\.?/g, "; record what ships through Claude for now."],
  [/decide the change with decide_po_change/g, "accept or reject the change first"],
];

/** Any other tool name: what it is in the app, or failing that, the tool's name in words. */
const TOOLS: Record<string, string> = {
  send_draft: "Send", review_draft: "Save changes", discard_draft: "Discard", vendor_po_pdf: "Open the PDF",
  approve_vendor_po: "Approve", withdraw_approval: "Withdraw the approval", decide_po_change: "Accept or Reject the change",
  settle_document: "the document's buttons", work_exception: "the exception's buttons", outbound_drafts: "the drafts",
  inbox: "Home", exceptions: "the exceptions", find_orders: "Orders", get_order: "the order",
  record_agent_shipment: "recording the shipment (through Claude for now)",
  record_agent_order: "recording the order (through Claude for now)",
};

export function plain(text: string | null | undefined): string {
  if (!text) return "";
  let s = text;
  for (const [re, to] of PHRASES) s = s.replace(re, to);
  return s.replace(/\b[a-z]+(?:_[a-z]+)+\b/g, (name) => TOOLS[name] ?? name)
    .replace(/\s{2,}/g, " ").replace(/\s+([.,;:])/g, "$1").trim();
}
